import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
  query Disambig ($id: ID!, $masterLimit: Int, $disambigTypes: String = "duplicate", $confidence: Float) {
    Disambig: FilmMaster (id: $id) {
      FilmDisambigResult (disambigTypes: $disambigTypes, confidence: $confidence) {
        filmMasterID
        totalItems
        maxScore
        Best {
          ...disResultDetail
        }
        FilmDisambigHits {
          ...disResultDetail
        }
      }
    }
  }
  ${fragments.disResultDetail}
  ${fragments.filmDetail}

  ${fragments.filmAwards}
   ${fragments.awardDetail}
   ${fragments.awardPrizeDetail}
   ${fragments.awardPrizeArtworks}
   ${fragments.artworkToArtifacts}

  ${fragments.filmMasters}
  ${fragments.filmMasterDetail}
  ${fragments.stripDetail}
  ${fragments.filmHost}
    ${fragments.filmMasterPosterFrames}
     ${fragments.artworkDetails}

  ${fragments.filmFiles}
   ${fragments.filmFileDetail}

`
